export const asyncServiceLoader = (callbackName) => async (args) => {
	const { setupServices } = (await import('services.setup.client'));
	const callbackExtracted = setupServices()[callbackName];
	return callbackExtracted(args);
};